import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getPageData } from 'utils/lib/strapi';

const useRegDExcludedList = () => {
  const queryClient = useQueryClient();
  const strapiContentId = queryClient.getQueryData(['strapiContentId']);
  const { data, isError, isSuccess, isLoading } = useQuery({
    queryKey: ['regDExcludedList', strapiContentId],
    queryFn: () =>
      getPageData({
        type: 'reg-d-exclusion-lists',
        preview: Boolean(strapiContentId),
        id: strapiContentId,
      }),
    refetchOnMount: true,
  });

  const parsedData = data?.attributes?.excludedRegDOfferingSlug?.map((item) => item?.value);
  const truthySuccess = isSuccess && data !== undefined;
  return {
    data: parsedData || [],
    isError,
    isLoading,
    isSuccess: truthySuccess,
  };
};

export default useRegDExcludedList;
